import { parseAsString, parseAsStringLiteral, useQueryStates } from "nuqs";
import { TimeEntryCategorySchema } from "@myapp/contract";
import {
  INITIAL_TIME_MANAGEMENT_FILTERS,
  TimeManagementFiltersForm,
} from "./timeManagementFilters.types";

const SORT_FIELDS = new Set<TimeManagementFiltersForm["sortField"]>([
  "category",
  "startTime",
  "endTime",
]);

const SORT_DIRECTIONS = new Set<TimeManagementFiltersForm["sortDirection"]>([
  "ASC",
  "DESC",
]);

export const useTimeManagementFiltersParams = () =>
  useQueryStates(
    {
      technicianName: parseAsString.withDefault(INITIAL_TIME_MANAGEMENT_FILTERS.technicianName),
      category: parseAsStringLiteral(TimeEntryCategorySchema.options),
      dateFrom: parseAsString.withDefault(INITIAL_TIME_MANAGEMENT_FILTERS.dateFrom),
      dateTo: parseAsString.withDefault(INITIAL_TIME_MANAGEMENT_FILTERS.dateTo),
      sortField: parseAsString.withDefault(INITIAL_TIME_MANAGEMENT_FILTERS.sortField),
      sortDirection: parseAsString.withDefault(INITIAL_TIME_MANAGEMENT_FILTERS.sortDirection),
    },
    {
      clearOnDefault: true,
    },
  );

export type TimeManagementFiltersParams = ReturnType<
  typeof useTimeManagementFiltersParams
>[0];

export const toTimeManagementFiltersForm = (
  params: TimeManagementFiltersParams,
): TimeManagementFiltersForm => ({
  technicianName: params.technicianName,
  category: params.category,
  dateFrom: params.dateFrom,
  dateTo: params.dateTo,
  sortField: SORT_FIELDS.has(params.sortField as TimeManagementFiltersForm["sortField"])
    ? (params.sortField as TimeManagementFiltersForm["sortField"])
    : INITIAL_TIME_MANAGEMENT_FILTERS.sortField,
  sortDirection: SORT_DIRECTIONS.has(
    params.sortDirection as TimeManagementFiltersForm["sortDirection"],
  )
    ? (params.sortDirection as TimeManagementFiltersForm["sortDirection"])
    : INITIAL_TIME_MANAGEMENT_FILTERS.sortDirection,
});
